/**
 * Case insensitive comparison
 */
export const ciEquals = (a: unknown, b: unknown) => {
  if (typeof a !== 'string' || typeof b !== 'string') {
    return a === b
  }

  return a.toLocaleLowerCase() === b.toLocaleLowerCase()
}
